'use es6';

import { createTracker } from 'usage-tracker';
import events from '../../events.yaml';
import { setPrimaryTracker } from 'usage-tracker-container';
import { REPORTING_TRACKER } from 'reporting-data/constants/usageTracker';
const trackerInstance = createTracker({
  events
});
setPrimaryTracker(trackerInstance, REPORTING_TRACKER);

// This is only exported to apply a spy during unit testing
export const ReportingTracker = createTracker({
  events,
  properties: {
    namespace: 'reporting'
  },
  onError: err => {
    // eslint-disable-next-line
    console.error(err);
  }
});
let currentSubscreen = null;
export const setProperties = properties => {
  ReportingTracker.setProperties(properties);
};
export const EVENTS = Object.keys(events).reduce((map, event) => Object.assign({}, map, {
  [event]: event
}), {});
export const trackEvent = (action, extras = {}) => {
  const {
    subscreen
  } = extras;
  if (subscreen) {
    currentSubscreen = subscreen;
  }
  ReportingTracker.track(action, Object.assign({
    screen: 'reports-list',
    subscreen: currentSubscreen,
    action
  }, extras));
};
export const EVENT_NAMES = {
  PAGE_VIEW: 'Page View',
  ACTIVATION_MILESTONE: 'Activation Milestone',
  REPORTS_LIST_INTERACTION: 'Reports List Interaction',
  ANALYTICS_INTERACTION: 'Analytics Interaction',
  REPORT_INTERACTION: 'Report Interaction'
};

//use for any new events that are not in events.yaml
export const StandaloneTracker = ReportingTracker.clone({
  standalone: true
});
export const standaloneTrackEvent = (eventName, action, extras = {}) => {
  StandaloneTracker.track('Reporting', eventName, Object.assign({
    action
  }, extras));
};